module.exports = __webpack_public_path__ + "static/media/8-min.f2bacc63.png";